export const NENDA_ZONE = "nenda.com";
export const NENDA_ZONES = [NENDA_ZONE, "nendaportals.com"];
const RESERVED_TLDS = new Set([
    "localhost",
    "local",
    "internal",
    "invalid",
    "test",
    "example",
    "onion",
    "arpa",
    "home",
    "lan",
    "corp",
    "intranet",
    "private",
]);
const IPV4 = /^\d{1,3}(\.\d{1,3}){3}$/;
const LABEL = /^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/;
function fail(error) {
    return { ok: false, error };
}
export function normalisePortalHost(input, options = {}) {
    var _a, _b;
    if (typeof input !== "string")
        return fail("empty");
    let s = input.trim().toLowerCase();
    if (!s)
        return fail("empty");
    if (s.length > 1024 || /\s/.test(s))
        return fail("invalid");
    s = s.replace(/^[a-z][a-z0-9+.-]*:\/\//, "");
    s = (_a = s.split(/[/?#\\]/, 1)[0]) !== null && _a !== void 0 ? _a : "";
    if (!s)
        return fail("empty");
    if (s.includes("@"))
        return fail("invalid");
    if (s.startsWith("["))
        return fail("ip_address");
    s = s.replace(/:\d*$/, "");
    if (s.includes(":"))
        return fail("ip_address");
    s = s.replace(/\.+$/, "");
    if (!s)
        return fail("empty");
    if (IPV4.test(s))
        return fail("ip_address");
    let ascii;
    try {
        ascii = new URL(`http://${s}/`).hostname;
    }
    catch {
        return fail("invalid");
    }
    ascii = ascii.replace(/\.+$/, "");
    if (IPV4.test(ascii) || ascii.startsWith("["))
        return fail("ip_address");
    if (ascii.length > 253)
        return fail("too_long");
    const labels = ascii.split(".");
    if (labels.some((l) => !LABEL.test(l)))
        return fail("invalid");
    if (labels.length < 2) {
        return fail(ascii === "localhost" ? "reserved" : "single_label");
    }
    const tld = labels[labels.length - 1];
    if (/^\d+$/.test(tld))
        return fail("invalid");
    if (RESERVED_TLDS.has(tld))
        return fail("reserved");
    if (NENDA_ZONES.some((z) => ascii === z || ascii.endsWith(`.${z}`))) {
        const allowed = ((_b = options.allowNendaHosts) !== null && _b !== void 0 ? _b : []).some((h) => h.trim().toLowerCase() === ascii);
        if (!allowed)
            return fail("nenda_domain");
    }
    return { ok: true, host: ascii };
}
export function portalHostOrNull(input, options) {
    const r = normalisePortalHost(input, options);
    return r.ok ? r.host : null;
}
export function portalCnameTarget(env) {
    return env === "dev"
        ? "portals-dev.nendaportals.com"
        : "portals.nendaportals.com";
}
export function isPortalKey(value) {
    return (typeof value === "string" &&
        /^[a-z0-9](?:[a-z0-9-]{1,61}[a-z0-9])$/.test(value));
}
